import React from "react";
import FaqAccordion from "../components/FaqAccordion";
import SpecialistScroller from "../components/SpecialistScroller";
import ServiceCards from "../components/ServiceCards";
import ServicesHeader from "../components/ServicesHeader";

const Services = () => {
  return (
    <>
      <div className="page-container">
        <ServicesHeader />
        <ServiceCards count={15} />
        <SpecialistScroller />
        <FaqAccordion />
      </div>
    </>
  );
};

export default Services;
